import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import store from './store';
import { getMe, setInitialized } from './store/authSlice';
import { fetchPublicOrg, setSlug } from './store/orgSlice';
import { applyTheme } from './utils/theme';
import { detectSlug } from './utils/subdomain';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import CatalogPage from './pages/CatalogPage';
import AktSverkaPage from './pages/AktSverkaPage';
import ProfilePage from './pages/ProfilePage';
import CartPage from './pages/CartPage';
import OrdersPage from './pages/OrdersPage';
import ProtectedRoute from './routes/ProtectedRoute';
import Layout from './components/Layout';

function PublicRoute({ children }) {
  const { isAuthenticated, initialized } = useSelector((s) => s.auth);
  if (!initialized) return null;
  return !isAuthenticated ? children : <Navigate to="/" replace />;
}

function Shell() {
  const dispatch = useDispatch();
  const { customer } = useSelector((s) => s.auth);
  const orgData = useSelector((s) => s.org.data);

  // Sessiyani tiklash: token bo'lsa — profil qayta yuklanadi.
  useEffect(() => {
    if (localStorage.getItem('client_token')) {
      dispatch(getMe());
    } else {
      dispatch(setInitialized());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Subdomendan tashkilot slug'ini aniqlab, login sahifasidan OLDIN branding
  // (nomi/logo/rang) ko'rsatish uchun oldindan yuklaymiz.
  useEffect(() => {
    const slug = detectSlug();
    if (slug) {
      dispatch(setSlug(slug));
      dispatch(fetchPublicOrg(slug));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Brend rangi — login'dan keyin mijoz tashkiloti (aniqroq), aks holda
  // login'dan oldingi pre-fetch qilingan branding.
  useEffect(() => {
    const brandColor = customer?.organization?.brandColor || orgData?.brandColor || null;
    applyTheme(brandColor);
  }, [customer, orgData]);

  return (
    <>
      <Toaster position="top-center" />
      <Routes>
        <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/catalog" element={<CatalogPage />} />
            <Route path="/akt" element={<AktSverkaPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/profile" element={<ProfilePage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
